import { api } from '../config'

export default {
  install (Vue, callback) {
    let parentSsoSystemUrl
    Vue.http.interceptors.response.handlers[0].rejected = function (error) {
      let data = (error && error.response && error.response.data) || {}
      if (error.config.url.includes('/api/admins/login')) { // 系统登录接口不进行错误统一处理
        return Promise.reject(error)
      }
      if (data.code === 401) {
        if (parentSsoSystemUrl) {
          window.parent.postMessage('401', parentSsoSystemUrl)
        } else {
          window.sessionStorage.clear()
          Vue.prototype.$message.info('登录过期，系统即将自动刷新登录')
          setTimeout(function () {
            location.href = location.origin || api
          }, 2000)
        }
      } else if (data.msg) {
        Vue.prototype.$message.error(data.msg)
      }
      return Promise.reject(error)
    }

    function clearSystemStorage () {
      window.localStorage.clear()
      window.sessionStorage.clear()
    }

    function getUrlParams(url){
      const paramObject = {}
      if(url.indexOf('?')>0){ // 判断是否有qurey
        let query = url.slice(url.indexOf('?')+1) // 截取出query
        const queryList = query.split('&') // 分割键值对
        for (const param of queryList) {
          let index = param.indexOf('=') // 以第一个=号分割
          paramObject[param.substr(0, index)] = param.substr(index + 1)
        }
      }
      return paramObject
    }

    function bindSingleEvent () {
      addHandler(window, 'message', function (e) {
        if (e.data) {
          parentSsoSystemUrl = e.data
        }
        if (e.data.parentURL) {
          parentSsoSystemUrl = e.data.parentURL
        }
      })
    }

    /* 接收单点登录parent消息 */
    function addHandler (element, type, handler) {
      if (element.addEventListener) {
        element.addEventListener(type, handler, false)
      } else if (element.attachEvent) {
        element.attachEvent('on' + type, handler)
      } else {
        element['on' + type] = handler
      }
    }
    const payload = getUrlParams(window.location.href)
    if (payload.data && payload.sign) {
      bindSingleEvent()
      clearSystemStorage() // sso单点登录重置缓存（sso退出时无法触发子系统清空缓存操作）
      Vue.http.request({
        method: 'post',
        url: '/api/admins/single-login',
        data: {
          data: payload.data.split('#')[0],
          sign: payload.sign.split('#')[0]
        }
      }).then((res) => {
        if (!res || !res.data || !res.data.data) return
        Vue.store.commit('user', res.data.data)
        Vue.router.replace('/')
        // eslint-disable-next-line
        callback(true)
      })
    } else {
      // eslint-disable-next-line
      callback(false)
    }
  }
}
